import { Title, SimpleCard, Divider } from '@libs/ui/ds'
import { Controller } from '@libs/ui/form'
import { useMemberPageTranslation } from '@libs/utils/translations'
import { useFormContext } from 'react-hook-form'

import type { NewUserFormType } from '../hooks/useNewUserForm'

export const ModulateContractContainer = () => {
  const { t } = useMemberPageTranslation()

  const {
    control,
    formState: { errors }
  } = useFormContext<NewUserFormType>()

  return (
    <SimpleCard data-testid='switch_modulate_eligible_contract'>
      <Title size={5}>{t('contract.info.form.modulation.title')}</Title>
      <Divider className='my-6' />
      <Controller.Switch
        position='right'
        control={control}
        label={t('contract.info.form.modulation.label')}
        desc={t('contract.info.form.modulation.description')}
        name='has_modulation_period'
        size='s'
        fillWidth
        defaultChecked
        errorMessage={errors?.has_modulation_period?.message}
      />
    </SimpleCard>
  )
}
